import React from 'react';
import { Navigate } from 'react-router-dom';
import { useIsPharmacySuperAdmin } from '../hooks/useIsPharmacySuperAdmin';

/** Only Super Admin / God (Admin login). Other users redirect to dashboard. */
const SuperAdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const ok = useIsPharmacySuperAdmin();
  if (!ok) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
};

export default SuperAdminRoute;
